import { render, staticRenderFns } from "./NewClinic.vue?vue&type=template&id=018424b6"
import script from "./NewClinic.vue?vue&type=script&lang=js"
export * from "./NewClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports